import axios from 'axios';

/**
 * 自定义上传图片插件
 */
class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  async upload() {
    const data = new FormData();
    data.append('name', await this.loader.file);

    const res = await axios({
      url: process.env.VUE_APP_API_UPLOAD_URL,
      method: 'POST',
      data,
    });
    return {
      default: res.data.data.url,
    };
  }
}

export default MyUploadAdapter;
